import { render } from "./OrganitzacioView.vue?vue&type=template&id=2912054c&scoped=true"
import script from "./OrganitzacioView.vue?vue&type=script&lang=js"
export * from "./OrganitzacioView.vue?vue&type=script&lang=js"

import "./OrganitzacioView.vue?vue&type=style&index=0&id=2912054c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2912054c"]])

export default __exports__